import React from 'react';
import { ButtonGroup, DropdownButton } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import _ from 'underscore';
import * as Fi from 'react-icons/fi';

const initialState = {
  privilege: null,
};

const Action = ({ data }) => {
  const Session = useSelector((state) => state.Auth?.session);

  const [{ privilege }, setState] = React.useState(initialState);

  const $getPriviledge = async () => {
    const x = _.findWhere(Session?.privileges, {
      service: 'nvo.tms.job',
    });
    setState((prevState) => ({ ...prevState, privilege: x }));
  };

  React.useEffect(() => {
    $getPriviledge();
  }, []);

  if (privilege?.action === 'manage' || !Session?.privileges) {
    if (data?.type === 'pickup' && data?.booking) {
      return (
        data?.status === 'new' && (
          <>
            <DropdownButton
              as={ButtonGroup}
              variant="transparent"
              size="md"
              className="no-carret tbl-action"
              title={<Fi.FiMoreVertical size={13} color="gray" />}
            >
              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/job-order/${data?.id}/update`}
              >
                <Fi.FiEdit size={15} color="#202020" className="me-2" />
                Perbaharui
              </Link>

              <Link
                className="dropdown-item d-flex align-items-center"
                role="button"
                to={`/job-order/${data?.id}/update`}
              >
                <Fi.FiTrash2 size={15} color="#202020" className="me-2" />
                Hapus
              </Link>
            </DropdownButton>
          </>
        )
      );
    }
  }

  return false;
};

export default Action;
